export default __webpack_public_path__ + "static/media/4.a45e4288.jpg";